import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {
    "NdStepContainer": () => import("./components/commons/NdStepContainer.vue"),
    "ListPlotSelector": () => import("./components/commons/ListPlotSelector.vue"),
    "MapPlotSelector": () => import("./components/commons/MapPlotSelector.vue"),
    "config-declaration": () => import("./components/commons/ConfigDeclaration.vue"),
    "NitratesDeclarationForm": () => import("./components/commons/NitratesDeclarationForm.vue"),
    "NdDetailsContainer": () => import("./components/NdDetailsContainer.vue"),
    "NdPlotSelectionContainer": () => import("./components/NdPlotSelectionContainer.vue"),
    "NdListContainer": () => import("./components/NdListContainer.vue"),
    "NdDocumentUploader": () => import("./components/NdDocumentUploader.vue"),
    "NdPrintTile": () => import("./components/tiles/NdPrintTile.vue"),
    "NdListTile": () => import("./components/tiles/NdListTile.vue"),
    "NdDetailsTile": () => import("./components/tiles/NdDetailsTile.vue"),
    "NdCattleList": () => import("./components/cattle/NdCattleList.vue"),
    "HeaderCattle": () => import("./components/tables/HeaderCattle.vue"),
    "header-table_a": () => import("./components/tables/HeaderTableA.vue"),
    "header-table_c": () => import("./components/tables/HeaderTableC.vue"),
    "FarmMaterials": () => import("./components/tables/FarmMaterials.vue"),
    "Effluents": () => import("./components/tables/Effluents.vue"),
    "Cattle": () => import("./components/tables/Cattle.vue"),
    "table_a": () => import("./components/tables/TableA.vue"),
    "storage_containers": () => import("./components/tables/StorageContainers.vue"),
    "storage_situation": () => import("./components/tables/StorageSituations.vue"),
    "nitrogen_soil": () => import("./components/tables/NitrogenSoil.vue"),
    "table_c": () => import("./components/tables/TableC.vue"),
    "table_d": () => import("./components/tables/TableD.vue"),
    "table_e": () => import("./components/tables/TableE.vue"),
    "table_lm": () => import("./components/tables/TableLM.vue"),
    "table_i": () => import("./components/tables/TableI.vue"),
    "spreadings": () => import("./components/tables/TableSpreadings.vue"),
    "table_farm_summary": () => import("./components/tables/TableFarmSummary.vue"),
    "p2_origin_of_waste_water": () => import("./components/details/OriginOfWasteWaters.vue"),
    "reporting_subject": () => import("./components/tables/ReportingSubject.vue"),
    "material_product_by_farm": () => import("./components/tables/MaterialProductByFarm.vue"),
    "p4_cc_table_n": () => import("./components/tables/TableN.vue"),
    "p5_waste_water_info": () => import("./components/tables/TableWasteWater.vue"),
    "p5_table_n": () => import("./components/tables/TableExcessWater.vue"),
    "QuadroForm": () => import("./components/quadri/QuadroForm.vue"),
    "QuadroManager": () => import("./components/quadri/QuadroManager.vue"),
    "Quadro4": () => import("./components/tables/Quadro4.vue"),
    "Quadro5": () => import("./components/tables/Quadro5.vue"),
    "NdCattleTreeNode": () => import("./components/cattle/NdCattleTreeNode.vue"),
    "NdCattleManager": () => import("./components/cattle/NdCattleManager.vue"),
    
    "NDChart": {
            meta: {
            i18nDescrKey: "nd-chart",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true,
            tag: "ND"
        },
        component: () => import("./components/chart/NDChart.vue")
    }
};

export default globals;
